import '../vendor/slick.js';

(function () {
  $(document).ready(function () {
    /** Slideshow **/
    $('.rotator').each(function () {
      var $this = $(this);

      $this.slick({
        slidesToShow: 1,
        arrows: true,
        speed: 1000,
        slidesToShow: 1,
        dots: true,
        infinite: true,
        fade: true,
        touchThreshold: 5000,
      });
    });

    /** Alerts **/
    var alertsCont = $('.alert-slider');
    var alerts = $('.alert-slider.isSlider .item-list');

    alerts.on('init', function (event, slick) {
      $('.header').addClass('alert-active');
      alertsCont.addClass($(slick.$slides[0]).data('col')).addClass('show');
    });

    alerts.slick({
      slidesToShow: 1,
      arrows: true,
      speed: 1000,
      slidesToShow: 1,
      dots: false,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      touchThreshold: 5000,
    });

    alerts.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      alertsCont.removeClass('red blue grey').addClass($(slick.$slides[nextSlide]).data('col'));
    });

    $('.toggleAlertsMobile').click(function () {
      $(this).toggleClass('active');
      $('.alert-slider .item-list').toggleClass('active');
    });

    /* News Slider */
    var newsSlider = $('.news.module.slider .items');

    newsSlider.on('init', function (event, slick) {
      $('.news.module.slider').children('.title').children('time').html($(slick.$slides[0]).children('time').html());
    });

    newsSlider.slick({
      autoplay: true,
      slidesToShow: 1,
      arrows: false,
      speed: 1000,
      dots: false,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      touchThreshold: 5000,
    });

    newsSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.news.module.slider')
        .children('.title')
        .children('time')
        .html($(slick.$slides[nextSlide]).children('time').html());
    });

    /* Spotlight */
    var spotSlider = $('.spotlight.slider .items');

    /*spotSlider.on('init', function(event, slick){

  });*/

    $('.image-container-slider').slick({
      slidesToShow: 1,
      arrows: false,
      speed: 1000,
      dots: false,
      infinite: false,
      fade: true,
    });

    spotSlider.slick({
      slidesToShow: 1,
      arrows: true,
      speed: 1000,
      dots: false,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      touchThreshold: 5000,
      asNavFor: '.image-container-slider',
    });
  });
})();
